const e = {
  "k-show-more": "Näytä lisää",
  "k-show-less": "Näytä vähemmän",
  "k-loading": "Ladataan",
  "k-close": "Sulje",
  "k-opensInNewTab": "Avautuu uuteen välilehteen",
  "k-modal-default-title": "Dialogi",
  "k-yes": "Kyllä",
  "k-no": "Ei",
  "k-ok": "Ok",
  "k-cancel": "Peruuta",
  "k-show-password": "Näytä salasana",
  "k-hide-password": "Piilota salasana",
  "k-select": "Valitse",
  "k-info-button": "Info painike",
  "k-search": "Hae",
  "k-clear": "Tyhjennä",
  "k-searching": "Haetaan...",
  "k-and-other-results": "...ja {0} muuta.",
  "k-no-results": "Ei tuloksia.",
  "k-select-file": "Valitse tiedosto, tai siirrä ja pudota se tähän.",
  "k-select-files": "Valitse tiedostot, tai siirrä ja pudota ne tähän.",
  "k-remove-file": "Poista tiedosto",
  "k-caps-lock": "Caps Lock on päällä. Kirjoitat isoilla kirjaimilla.",
  "k-date-start": "Alkupäivä",
  "k-date-end": "Loppupäivä",
  "k-html-editor": { "text-styles": { heading1: "Otsikko 1", heading2: "Otsikko 2", heading3: "Otsikko 3", heading4: "Otsikko 4", heading5: "Otsikko 5", heading6: "Otsikko 6", paragraph: "Leipäteksti" }, textStyles: "Valitse tekstityyli", bulletList: "Luettelo", orderedList: "Numeroitu luettelo", undo: "Kumoa", redo: "Tee uudelleen", bold: "Lihavointi", italic: "Kursivointi", underline: "Alleviivaus", strike: "Yliviivaus", link: "Linkki", "add-image": "Lisää kuva", "link-button": { "add-link": "Lisää linkki", url: "URL", confirm: "Lisää", "invalid-url": "Anna kelvollinen URL-osoite" }, "image-button": { "add-image": "Lisää kuva", url: "Kuvan URL", confirm: "Lisää", "invalid-url": "Anna kelvollinen URL-osoite" } },
  "k-copy": "Kopioi",
  "k-copied": "Kopioitu!"
}, i = {
  "k-show-more": "Show more",
  "k-show-less": "Show less",
  "k-loading": "Loading",
  "k-close": "Close",
  "k-opensInNewTab": "Opens in a new tab",
  "k-modal-default-title": "Dialog",
  "k-yes": "Yes",
  "k-no": "No",
  "k-ok": "Ok",
  "k-cancel": "Cancel",
  "k-show-password": "Show password",
  "k-hide-password": "Hide password",
  "k-select": "Select",
  "k-info-button": "Info button",
  "k-search": "Search",
  "k-clear": "Clear",
  "k-searching": "Searching...",
  "k-and-other-results": "...and {0} other results.",
  "k-no-results": "No results.",
  "k-select-file": "Select a file or drag-and-drop it here.",
  "k-select-files": "Select files or drag-and-drop them here.",
  "k-remove-file": "Remove file",
  "k-caps-lock": "Caps Lock is on. You are writing with capital letters.",
  "k-date-start": "Start date",
  "k-date-end": "End date",
  "k-html-editor": { "text-styles": { heading1: "Heading 1", heading2: "Heading 2", heading3: "Heading 3", heading4: "Heading 4", heading5: "Heading 5", heading6: "Heading 6", paragraph: "Paragraph" }, textStyles: "Select text style", bulletList: "Bullet list", orderedList: "Ordered list", undo: "Undo", redo: "Redo", bold: "Bold", italic: "Italic", underline: "Underline", strike: "Strikethrough", link: "Link", "add-image": "Add image", "link-button": { "add-link": "Add link", url: "URL", confirm: "Add", "invalid-url": "Please enter a valid URL" }, "image-button": { "add-image": "Add image", url: "Image URL", confirm: "Add", "invalid-url": "Please enter a valid URL" } },
  "k-copy": "Copy",
  "k-copied": "Copied!"
}, a = {
  "k-show-more": "Visa mer",
  "k-show-less": "Visa mindre",
  "k-loading": "Laddning",
  "k-close": "Nära",
  "k-opensInNewTab": "Öppnas i ny flik",
  "k-modal-default-title": "Dialog",
  "k-yes": "Ja",
  "k-no": "Nej",
  "k-ok": "Ok",
  "k-cancel": "Avbryt",
  "k-show-password": "Visa lösenord",
  "k-hide-password": "Dölj lösenord",
  "k-select": "Välj",
  "k-info": "Info knapp",
  "k-search": "Sök",
  "k-clear": "Klart",
  "k-searching": "Söker...",
  "k-and-other-results": "...och {0} andra resultat.",
  "k-no-results": "Inga resultat.",
  "k-select-file": "Välj en fil eller dra och släpp den här.",
  "k-select-files": "Välj filer eller dra och släpp dem här.",
  "k-remove-file": "Ta bort fil",
  "k-caps-lock": "Caps Lock är aktiverat. Du skriver med stora bokstäver.",
  "k-date-start": "Startdatum",
  "k-date-end": "Slutdatum",
  "k-html-editor": { "text-styles": { heading1: "Rubrik 1", heading2: "Rubrik 2", heading3: "Rubrik 3", heading4: "Rubrik 4", heading5: "Rubrik 5", heading6: "Rubrik 6", paragraph: "Stycke" }, textStyles: "Välj textstil", bulletList: "Punktlista", orderedList: "Numrerad lista", undo: "Ångra", redo: "Gör om", bold: "Fetstil", italic: "Kursiv", underline: "Understrykning", strike: "Genomstrykning", link: "Länk", "add-image": "Lägg till bild", "link-button": { "add-link": "Lägg till länk", url: "URL", confirm: "Lägg till", "invalid-url": "Ange en giltig URL" }, "image-button": { "add-image": "Lägg till bild", url: "Bildens URL", confirm: "Lägg till", "invalid-url": "Ange en giltig URL" } },
  "k-copy": "Kopiera",
  "k-copied": "Kopierat!"
};
export {
  i as en,
  e as fi,
  a as sv
};
